import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

// Custom theme configuration
const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: '#E8F4F5' },
          100: { value: '#D2E9EB' },
          200: { value: '#B3DADE' },
          300: { value: '#8DC7CE' },
          400: { value: '#68B5BE' },
          500: { value: '#42A2AD' },
          600: { value: '#1C909D' }, // Primary brand color
          700: { value: '#177883' },
          800: { value: '#136069' },
          900: { value: '#0F4A50' },
        },
        semantic: {
          success: { value: '#36B37E' },
          warning: { value: '#FFAB00' },
          info: { value: '#0065FF' },
          help: { value: '#6554C0' },
          neutral: { value: '#EBECF0' },
        },
        error: {
          light: { value: '#E35771' },
          regular: { value: '#DD3554' },
          dark: { value: '#BE2650' },
        },
      },
      fonts: {
        heading: { value: 'Inter, system-ui, sans-serif' },
        body: { value: 'Inter, system-ui, sans-serif' },
      },
      spacing: {
        4.5: { value: '1.125rem' }, // 18px
        18: { value: '4.5rem' },    // 72px
        22: { value: '5.5rem' },    // 88px
        26: { value: '6.5rem' },    // 104px
      },
    },
    semanticTokens: {
      colors: {
        // Brand semantic tokens
        brand: {
          solid: { value: '{colors.brand.600}' },
          contrast: { value: '{colors.brand.50}' },
          fg: { value: '{colors.brand.700}' },
          muted: { value: '{colors.brand.100}' },
          subtle: { value: '{colors.brand.50}' },
          emphasized: { value: '{colors.brand.200}' },
          focusRing: { value: '{colors.brand.600}' },
        },
        // UI state semantic tokens
        success: {
          solid: { value: '{colors.semantic.success}' },
          subtle: { value: 'color-mix(in srgb, {colors.semantic.success}, transparent 90%)' },
          muted: { value: 'color-mix(in srgb, {colors.semantic.success}, transparent 80%)' },
        },
        error: {
          solid: { value: '{colors.error.regular}' },
          light: { value: '{colors.error.light}' },
          dark: { value: '{colors.error.dark}' },
          subtle: { value: 'color-mix(in srgb, {colors.error.regular}, transparent 90%)' },
          muted: { value: 'color-mix(in srgb, {colors.error.regular}, transparent 80%)' },
        },
        warning: {
          solid: { value: '{colors.semantic.warning}' },
          subtle: { value: 'color-mix(in srgb, {colors.semantic.warning}, transparent 90%)' },
          muted: { value: 'color-mix(in srgb, {colors.semantic.warning}, transparent 80%)' },
        },
        info: {
          solid: { value: '{colors.semantic.info}' },
          subtle: { value: 'color-mix(in srgb, {colors.semantic.info}, transparent 90%)' },
          muted: { value: 'color-mix(in srgb, {colors.semantic.info}, transparent 80%)' },
        },
        help: {
          solid: { value: '{colors.semantic.help}' },
          subtle: { value: 'color-mix(in srgb, {colors.semantic.help}, transparent 90%)' },
          muted: { value: 'color-mix(in srgb, {colors.semantic.help}, transparent 80%)' },
        },
        neutral: {
          solid: { value: '{colors.semantic.neutral}' },
          subtle: { value: 'color-mix(in srgb, {colors.semantic.neutral}, transparent 50%)' },
        },
      },
    },
  },
  globalCss: {
    body: {
      bg: 'gray.50',
      _dark: { bg: 'gray.900' },
    },
  },
});

// Create the system
const system = createSystem(defaultConfig, config);

export default system; 